import { Box } from "@mui/material";
import { useMemo } from "react";

import { ACCOUNT_STATUS } from "../../../models/Customer";
import { warning } from "../../../theme/colors";
import Text from "../../atoms/Text";

export const Status = (label: string) => {
  const bgColor = useMemo(() => {
    switch (label) {
      case ACCOUNT_STATUS.VERIFIED:
        return "#B5D29D";
      case ACCOUNT_STATUS.UNVERIFIED:
        return warning.light;
      case ACCOUNT_STATUS.LOCKED:
        return "#FFAFAF";
      case ACCOUNT_STATUS.TOBEDELETED:
        return "#FAE4D3";
      case ACCOUNT_STATUS.ARCHIVED:
        return "#CCEAEE";
      default:
        return "transparent";
    }
  }, [label]);
  return (
    <Box bgcolor={bgColor} width="100%" height="100%">
      <Text
        variant="subtitle_small"
        textAlign="center"
        height="56px"
        lineHeight="56px"
        textTransform="capitalize"
      >
        {label === ACCOUNT_STATUS.TOBEDELETED
          ? "To be deleted"
          : label?.toLowerCase()}
      </Text>
    </Box>
  );
};
